<mat-expansion-panel class="saved-panel" [expanded]="true">
  <mat-expansion-panel-header>
    <mat-panel-title
      ><b>{{ title | translate }}</b></mat-panel-title
    >
  </mat-expansion-panel-header>

  <ng-container *ngIf="(savedFilters$ | async)?.length">
    <div class="saved-item" *ngFor="let saved of savedFilters$ | async; trackBy: trackById" (click)="onSelect(saved)">
      <a class="saved-link">
        {{ saved.title }}
      </a>
      <span class="spacer"></span>
      <mat-icon class="action-icon" (click)="onEdit(saved); $event.stopPropagation()">edit</mat-icon>
      <mat-icon class="action-icon" (click)="onDelete(saved.identifier); $event.stopPropagation()">delete</mat-icon>
    </div>
  </ng-container>
</mat-expansion-panel>
